import { render, staticRenderFns } from "./ConfirmMdokSubmit.vue?vue&type=template&id=4d0aca6e&"
import script from "./ConfirmMdokSubmit.vue?vue&type=script&lang=js&"
export * from "./ConfirmMdokSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports